import React from 'react'
import './index.less'
import jump from 'src/helper/jumpToApp'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle } from 'src/helper/tool'
import { history } from 'src/core/router'
import brower from 'src/helper/brower'
import { getlang } from 'src/helper/getlang'
import Msg from 'src/component/Message'
import Toast from 'src/component/Toast'
const { appLink } = jump
const { AppStore, googlePlay, apkHW, apkURL } = appLink

@inject('store')
@observer
export default class extends React.Component {
  state = {
    lang: {},
    flag: false,
    initShareTraceOut: false,
    code: '',
    barnd: '',
    language: '',
    wenfrg: false,
    isShowApkAndRecharge: true,
    showGOLDEN: false,
    toastContent: '',
    companyName: '',
  }

  constructor(props) {
    super(props)
    this.homePcStore = this.props.store.register('home/pcnew')
    setDocumentTitle(`Yayya - Free group voice chat app`)
  }

  /**
   * @description 跳转PC
   */
  goPC() {
    const isApp = !brower.isIphone() && !brower.isAndroid() && !brower.isWeixin()
    if (isApp) {
      let map = {
        pathname: `/home/pc`,
      }

      if (this.state.code && this.state.code != '') {
        map.query = {
          code: this.state.code,
          activity: this.props.location.query.activity,
        }
      }

      history.push(map)
    }
  }
  judgeBrand = (sUserAgent) => {
    var isIphone = sUserAgent.match(/iphone/i) == 'iphone'
    var isHuawei = sUserAgent.match(/huawei/i) == 'huawei'
    if (isIphone) {
      return 'iphone'
    } else if (isHuawei) {
      return 'huawei'
    } else {
      return 'android'
    }
  }

  async componentWillMount() {
    // 根据设备类型跳转到指定网页
    let targetUrl = 'https://web.yayya.live/' // 默认跳转地址
    if (brower.isIphone()) {
      // iOS 设备跳转到 yayya.live
      targetUrl = 'https://web.yayya.live/'
    } else if (brower.isAndroid()) {
      // Android 设备跳转到 yayya.chat
      targetUrl = 'https://web.yayya.chat/'
    }
    window.location.href = targetUrl
  }

  selectDomain() {
    const domain = window.location.hostname
    if (domain.endsWith('yayya.chat')) {
      return '广州次境互联科技有限公司'
    } else if (domain.endsWith('yayya.live')) {
      return '广州光之夜科技有限公司'
    } else {
      return '广州光之夜科技有限公司'
    }
  }

  /**
   * @description 初始化语言
   */
  async initLang() {
    let language = await getlang()
    let lang = await this.homePcStore.getLang(language)
    this.setState({
      lang: lang,
    })
  }

  async componentDidMount() {
    // 打印参数信息
    console.log(navigator.userAgent, 'navigator.userAgent')
    console.log(brower.isHuawei(), 'is huawei')

    const meta1 = document.createElement('meta')
    meta1.httpEquiv = 'Cache-Control'
    meta1.content = 'no-store, no-cache, must-revalidate, max-age=0'

    const meta2 = document.createElement('meta')
    meta2.httpEquiv = 'Pragma'
    meta2.content = 'no-cache'

    const meta3 = document.createElement('meta')
    meta3.httpEquiv = 'Expires'
    meta3.content = '0'

    document.head.appendChild(meta1)
    document.head.appendChild(meta2)
    document.head.appendChild(meta3)

    // 初始化语言
    this.initLang()
  }

  async showToast() {
    this.setState({
      toastContent: 'Coming soon...',
    })
    this.refs.toast.hideRule(true)
  }

  download(type) {
    this.showToast()
    return
    const urlApple = AppStore
    const urlHuaWei = apkHW
    const urlAndroid = googlePlay
    const urlApk = apkURL
    switch (type) {
      case 1: {
        // 苹果
        // ShareTrace.preDownload(function () {
        console.log('apple shareTrace')
        window.location.href = urlApple

        // });
        if (!this.state.initShareTraceOut) {
          console.log('apple normal')
          window.location.href = urlApple
        }
        break
      }
      case 2: {
        // 华为
        // ShareTrace.preDownload(function () {
        console.log('huawei shareTrace')
        window.location.href = urlHuaWei

        // });
        if (!this.state.initShareTraceOut) {
          console.log('huawei normal')
          window.location.href = urlHuaWei
        }
        break
      }
      case 3: {
        // 安卓
        // ShareTrace.preDownload(function () {
        console.log('android shareTrace')
        window.location.href = urlAndroid

        // });
        if (!this.state.initShareTraceOut) {
          console.log('android normal')
          window.location.href = urlAndroid
        }
        break
      }
      case 4: {
        // 安卓
        // ShareTrace.preDownload(function () {
        console.log('android shareTrace')
        window.location.href = urlApk

        // });
        if (!this.state.initShareTraceOut) {
          console.log('android apk')
          window.location.href = urlApk
        }
        break
      }
      default:
    }
  }

  /**
   * @description 下载按钮组件
   */
  downloadComp() {
    {
      /* 先判断是安卓还是苹果，如果是安卓，再次判断是否华为？ */
    }
    let { barnd, isShowApkAndRecharge } = this.state
    console.log(barnd, '-------barnd-----')
    const showComp = () => {
      if (barnd == 'iphone') {
        return (
          <div
            onClick={() => {
              this.download(1)
            }}
            className="apl"
          ></div>
        )
      } else if (barnd == 'huawei') {
        return (
          <div>
            <div
              onClick={() => {
                this.download(3)
              }}
              className="gg"
            ></div>
            <div
              onClick={() => {
                this.download(2)
              }}
              className="hw"
            ></div>
          </div>
        )
      } else {
        return (
          <div>
            <div
              onClick={() => {
                this.download(3)
              }}
              className="gg"
            ></div>
            {isShowApkAndRecharge === true && (
              <div
                onClick={() => {
                  this.download(4)
                }}
                className="apk"
              ></div>
            )}
          </div>
        )
      }
    }
    return <div className="download">{showComp()}</div>
  }

  /**
   * @description 充值跳转
   */
  handleRecharge() {
    history.push('/app/recharge')
  }

  jumpPage() {
    history.push({
      pathname: `/app/termsofuse`,
      query: {},
    })
  }

  render() {
    let { lang, isShowApkAndRecharge, language, toastContent } = this.state
    return (
      <div className="home-mb-App">
        {/* 提示 */}
        <Msg ref="msg"></Msg>

        <div className="main-wrap">
          <div className="header">
            <div className="left">
              <div className="logo"></div>
            </div>
            {/* {<div className="code" style={{ opacity: this.props.location.query.c == 'y' ? 1 : 0 }}></div>} */}
            {
              // isShowApkAndRecharge === true && (
              //   <div
              //     style={{ unicodeBidi: `${this.state.language == 'ar' && 'bidi-override'}` }}
              //     className="recharge"
              //     onClick={() => { this.handleRecharge() }}>{lang.recharge}
              //   </div>
              // )
            }
          </div>

          {/* 主要内容 */}
          <div className="main-content">
            <div className="body">
              <div className="title">No words. Still felt</div>
              <div className="phone-wrap">
                {/* <div className="phone"></div> */}
                {/* <video autoPlay loop muted play="true" playsInline={true} webkit-playsinline="true">
                  <source src="/img/home/pcnew/hobi_websiz.mp4" type="video/mp4" />
                  Your browser doesn't support video.
                </video> */}
                {/* <img src="/img/home/pcnew/df.jpg" alt="" className="df_bg2" /> */}
                <div className="df_bg"></div>
              </div>
              <div className="yy"></div>
              {this.downloadComp()}
            </div>
            <div className="footer">
              <div className="us">
                <div
                  className="about"
                  onClick={() => {
                    history.push('/home/about')
                  }}
                >
                  {lang.about}
                </div>
                <div className="space"></div>
                <div
                  className="contact"
                  onClick={() => {
                    history.push('/home/about')
                  }}
                >
                  {lang.contact}
                </div>
                {/* <div className="space"></div> */}
                {/* <div className="contact" onClick={() => { this.jumpPage() }}>{lang.terms}</div> */}
              </div>
              <div className="copyright">Copyright ©2025 {this.state.companyName}</div>
            </div>
          </div>
        </div>
        <Toast language={language} lang={lang} ref="toast" id="toast" toastContent={toastContent} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/home/mobile/index.js